import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconSend: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 15}
      height={height ?? 15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9984 0.665039L9.33171 13.9984L6.66504 7.99837M13.9984 0.665039L0.665039 5.33171L6.66504 7.99837M13.9984 0.665039L6.66504 7.99837"
        stroke={color ?? "#FAFAFA"}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
